var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgListIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.98438 18.8594H21.0781M9.98438 13.3125H21.0781M9.98438 7.76562H21.0781M5.54904 18.8594V18.8616L5.54688 18.8615V18.8594H5.54904ZM5.54904 13.3125V13.3147L5.54688 13.3147V13.3125H5.54904ZM5.54904 7.76562V7.76784L5.54688 7.76779V7.76562H5.54904Z",
    stroke: "#0E0E0E",
    strokeWidth: 2.21875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListIcon);
export default __webpack_public_path__ + "static/media/ListIcon.e3dc7f6dc31df6fd56fc8b7d58d82328.svg";
export { ForwardRef as ReactComponent };